import React from 'react';

function AppHeader({ credits, error, title, subtitle }) {
  return (
    <div className="app-header-wrapper">
      <div className="app-header">
        {/* Title and Subtitle on the Left */}
        {title && (
          <div className="header-title-section">
            <h1 className="header-title">{title}</h1>
            {subtitle && <p className="header-subtitle">{subtitle}</p>}
          </div>
        )}

        {/* Credits on the Right */}
        <div className="header-content">
          <div className="header-credits-wrapper">
            <span className="header-credits-icon">⭐</span>
            <div className="header-credits-info">
              <span className="header-credits-label">Credits</span>
              <span className="header-credits-value">{credits}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Error Alert */}
      {error && (
        <div className="error-alert">
          <p>{error}</p>
        </div>
      )}
    </div>
  );
}

export default AppHeader;
